(() => {
    const sidebar = document.querySelector('[data-mobile-navigation-sidebar]');
    const sidebarToggles = document.querySelectorAll('[data-mobile-navigation-sidebar-toggle]');

    sidebarToggles.forEach((sidebarToggle) => {
        sidebarToggle.addEventListener('click', () => {
            sidebar.classList.toggle('is-active');
        });
    });
})();

(() => {
    const desktopNavigation = document.querySelector('.desktop-navigation');
    const desktopNavigationMenuItems = document.querySelectorAll('.desktop-navigation-menu__item');

    const closeDropdowns = () => {
        desktopNavigationMenuItems.forEach((desktopNavigationMenuItem) => {
            desktopNavigationMenuItem.classList.remove('dropdown-open');
        })
    };

    desktopNavigation.addEventListener('mouseleave', () => {
        closeDropdowns();
    });

    desktopNavigationMenuItems.forEach((desktopNavigationMenuItem) => {
        desktopNavigationMenuItem.addEventListener('mouseenter', () => {
            closeDropdowns();
            desktopNavigationMenuItem.classList.add('dropdown-open');
        });
    });
})();
